<div class="no-navigation-header">
  <img id="logo" class="logo" alt="RIDE COMMAND®" [ngSrc]="`/assets/images/${brand}/logo.svg`" i18n-alt />
</div>
